import * as yup from "yup";

export const alert_schema = {
  symbol_name: "",
  symbol_code: "",
  where: "",
  condition: "",
  value: "",
  expiry_date: "",
};

export const alert_validation_schema = yup.object().shape({
  symbol_name: yup.string().required("symbol_required_validation"),
  symbol_code: yup.string(),
  where: yup.object().required("where_required_validation"),
  condition: yup.object().required("condition_required_validation"),
  value: yup.string().required("value_required_validation"),
  expiry_date: yup.string().required("expiry_date_required_validation"),
});
